/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { SigninUserData } from '@app/core/services';
import { GmcError } from '@app/core/types';
import { AuthNotificationType } from '@app/public/types';
import { createAction, props } from '@ngrx/store';
import { AuthConfig, ResetPasswordInfo } from '@shared/types/auth';
import { Cluster2xConnectionToken } from '@shared/types/cluster';
import { SignupUserData, User } from '@shared/types/common';

export const login = createAction('[User] Login', props<{ user: User }>());
export const getUser = createAction('[User] Get User');
export const getUserSuccess = createAction('[User] Get User Success', props<{ user: User }>());
export const signin = createAction('[User] Signin', props<{ data: SigninUserData }>());
export const signinSuccess = createAction('[User] Signin Success');
export const signinFailure = createAction('[User] Signin Failure', props<GmcError>());
export const signup = createAction('[User] Signup', props<{ data: SignupUserData }>());
export const emailNeedsConfirmation = createAction(
  '[User] Email Need Confirmation',
  props<{ email: string; authType: AuthNotificationType }>(),
);
export const signupSuccess = createAction('[User] Signup Success');
export const signupFailure = createAction('[User] Signup Failure', props<GmcError>());
export const logout = createAction('[User] Logout');
export const logoutSuccess = createAction('[User] Logout Success');
export const logoutFailure = createAction('[User] Logout Failure', props<GmcError>());
export const initUser = createAction('[User] Init Current User');
export const connectionToken = createAction(
  '[Auth] Connection token',
  props<{ connectionToken?: Cluster2xConnectionToken }>(),
);
export const getUserFailure = createAction(`[User] Can't get Current User`, props<GmcError>());
export const sendActivation = createAction('[User] Send Activation', props<{ email: string }>());
export const sendActivationSuccess = createAction('[User] Send Activation Success', props<{ notification: string }>());
export const sendActivationFailure = createAction('[User] Send Activation Failure', props<GmcError>());
export const remindPassword = createAction('[User] Remind Password', props<{ email: string }>());
export const remindPasswordSuccess = createAction('[User] Remind Password Success');
export const remindPasswordFailure = createAction('[User] Remind Password Failure', props<GmcError>());
export const resetPassword = createAction('[User] Reset Password', props<{ data: ResetPasswordInfo }>());
export const resetPasswordSuccess = createAction('[User] Reset Password Success', props<{ notification: string }>());
export const resetPasswordFailure = createAction('[User] Reset Password Failure', props<GmcError>());
export const navigateToSignupFailure = createAction('[User] Navigation to signup failed', props<GmcError>());
export const authConfig = createAction('[Auth] Auth config', props<{ config: AuthConfig }>());
export const getAuthConfigErr = createAction('[Auth] Get auth config error', props<GmcError>());
export const grantAdminSuccess = createAction('[User] Grant Admin Success', props<{ notification: string }>());
